;
define("facets_browse_category_heading.tpl", function(){});

